import PropTypes from 'prop-types'
import React from 'react'

const AdditionalConfigSuggestedRequiredOption = ({ isReceptionDesk }) => {
  const contextLabel = isReceptionDesk ? 'creados con la plantilla Mesa de partes' : 'de la entidad'
  return (
    <>
      <span>Será sugerido durante el proceso de creación de los formularios {contextLabel}.</span>
      <br />
      <span>
        El creador del formulario puede editar el horario o mantener el sugerido
        {isReceptionDesk && ' , pero este será un campo obligatorio'}.
      </span>
    </>
  )
}

export default AdditionalConfigSuggestedRequiredOption

AdditionalConfigSuggestedRequiredOption.propTypes = {
  isReceptionDesk: PropTypes.bool
}
